import browserFormat from './outputFunctionCallInfo.browser.js';

export default function outputFunctionCallInfo(functionName, params, res, duration, options) {
  browserFormat(functionName, params, res, duration, options);
}
